import { Carrier, CarrierCreateRequest, CarrierUpdateRequest } from "@bluefalcon/clients-management-client-fetch";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    FormControl,
    FormLabel,
    Input,
    IconButton,
} from "@chakra-ui/react";
import { LoadingSpinner } from "../components/base/loading-spinner/loading-spinner.comp";

type AddEditCarrierModalProps = {
    modalState: boolean;
    carrier?: Carrier;
    handleAddCarrier: (data: CarrierCreateRequest) => Promise<void>;
    handleEditCarrier: (carrierId: number, data: CarrierUpdateRequest) => Promise<void>;
    handleDeleteCarrier: (carrierId: number) => Promise<void>;
    closeModal: () => void;
};

export const AddEditCarrierModal = ({
    modalState,
    carrier,
    handleAddCarrier,
    handleEditCarrier,
    handleDeleteCarrier,
    closeModal,
}: AddEditCarrierModalProps) => {
    const [carrierName, setCarrierName] = useState(carrier?.name ?? "");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setCarrierName(carrier?.name ?? "");
    }, [carrier]);

    const handleSubmit = async () => {
        try {
            setIsLoading(true);
            if (carrier && carrierName.trim()) {
                await handleEditCarrier(carrier.id, { name: carrierName.trim(), policies: {} });
            } else if (carrierName.trim()) {
                await handleAddCarrier({ name: carrierName.trim() });
            }
        } catch (error) {

        } finally {
            setIsLoading(false);
            onCloseModal();
        }
    };

    const handleDelete = async () => {
        if (carrier) {
            await handleDeleteCarrier(carrier.id);
        }
        onCloseModal();
    };

    const onCloseModal = () => {
        setCarrierName("");
        closeModal();
    };

    return (
        <Modal isOpen={modalState} onClose={onCloseModal}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{carrier ? "Edit Carrier" : "Add Carrier"}</ModalHeader>
                <ModalCloseButton />
                {!isLoading ? <ModalBody>
                    <FormControl mb={4}>
                        <FormLabel htmlFor="carrierName">Carrier Name</FormLabel>
                        <Input
                            id="carrierName"
                            value={carrierName}
                            onChange={(e) => setCarrierName(e.target.value)}
                            placeholder="Enter carrier name"
                        />
                    </FormControl>
                </ModalBody> : <LoadingSpinner />}

                <ModalFooter>
                    {/* {carrier && (
                        <IconButton
                            aria-label="Delete Carrier"
                            icon={<FontAwesomeIcon icon={faTrashCan} />}
                            variant="outline"
                            onClick={handleDelete}
                            mr="auto"
                        />
                    )} */}
                    <Button isDisabled={isLoading} variant="outline" onClick={onCloseModal}>
                        Close
                    </Button>
                    <Button isDisabled={!carrierName.trim()} colorScheme="teal" ml={3} onClick={handleSubmit}>
                        {carrier ? "Edit Carrier" : "Add Carrier"}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};
